import React from 'react';

/**
 * Read-only list of the per-channel "Explore with ALEX" links (ADM-1823).
 *
 * Labels come from the server (FieldNoteSerializer::CHANNEL_LABELS) rather than a second
 * copy of the channel list here, so a channel added server-side cannot reach the admin as
 * a raw key.
 *
 * Layout: the label and the URL are separate block-level elements, so they cannot run
 * together even if a class below stops resolving. That is deliberate — the bug this
 * replaced relied on `w-28` to hold a label column, and `w-28` is a Tailwind 3 class our
 * Tailwind 0.7 build (see /tailwind.js) never generated, so the label sat flush against
 * the URL. Every class used here is present in that config.
 *
 * @param {Array<{channel: string, label: string, url: string}>} exploreLinks
 */
const ExploreLinksList = ({ exploreLinks }) => {
  const links = exploreLinks || [];

  // The server always sends every channel, so an empty list means the response did not carry
  // explore_links at all — a browser holding this page across a deploy is the realistic case.
  // Say so, rather than leaving a blank region under the "Explore links for …" heading.
  // No text colour class: the admin shell's `.admin-user p { color: #3c3c3c }` outranks any
  // single-class text-* utility, so one here would resolve and still never win.
  if (links.length === 0) {
    return (
      <p className="mb-6">
        No explore links came back for this note. Reload the page and save again.
      </p>
    );
  }

  return (
    <ul className="mb-6">
      {links.map(({ channel, label, url }) => (
        <li key={channel} className="mb-3" data-channel={channel}>
          <span className="block font-medium">{label}</span>
          <code className="block text-sm font-mono break-words">{url}</code>
        </li>
      ))}
    </ul>
  );
};

export default ExploreLinksList;
